"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var Box_1 = require("../Box");
var TableCell_1 = require("../TableCell");
var TableHeader_1 = require("../TableHeader");
var TableRow_1 = require("../TableRow");
var Text_1 = require("../Text");
var ExpanderCell_1 = require("./ExpanderCell");
var Resizer_1 = require("./Resizer");
var Searcher_1 = require("./Searcher");
var Sorter_1 = require("./Sorter");
var StyledDataTable_1 = require("./StyledDataTable");
var Header = function (_a) {
    var columns = _a.columns, filtering = _a.filtering, filters = _a.filters, groups = _a.groups, groupState = _a.groupState, onFilter = _a.onFilter, onFiltering = _a.onFiltering, onResize = _a.onResize, onSort = _a.onSort, onToggle = _a.onToggle, sort = _a.sort, theme = _a.theme, widths = _a.widths, rest = tslib_1.__rest(_a, ["columns", "filtering", "filters", "groups", "groupState", "onFilter", "onFiltering", "onResize", "onSort", "onToggle", "sort", "theme", "widths"]);
    var dataTableContextTheme = tslib_1.__assign(tslib_1.__assign({}, theme.table.header), theme.dataTable.header);
    // tslint:disable-next-line:no-shadowed-variable
    var outerThemeProps = (function (_a) {
        var border = _a.border, background = _a.background;
        return ({
            border: border,
            background: background
        });
    })(dataTableContextTheme);
    var border = dataTableContextTheme.border, background = dataTableContextTheme.background, innerThemeProps = tslib_1.__rest(dataTableContextTheme, ["border", "background"]);
    return (react_1.default.createElement(StyledDataTable_1.StyledDataTableHeader, tslib_1.__assign({ as: TableHeader_1.TableHeader }, rest),
        react_1.default.createElement(StyledDataTable_1.StyledDataTableRow, { as: TableRow_1.TableRow },
            groups && (react_1.default.createElement(ExpanderCell_1.ExpanderCell, { context: "header", expanded: Object.keys(groupState).filter(function (k) { return !groupState[k].expanded; }).length === 0, onToggle: onToggle })),
            columns.map(function (_a) {
                var property = _a.property, header = _a.header, align = _a.align, search = _a.search;
                var content = typeof header === 'string' ? react_1.default.createElement(Text_1.Text, null, header) : header;
                if (onSort) {
                    content = (react_1.default.createElement(Sorter_1.Sorter, { align: align, fill: !search, property: property, onSort: onSort, sort: sort, themeProps: search ? innerThemeProps : dataTableContextTheme }, content));
                }
                if (search && filters) {
                    if (!onSort) {
                        content = (react_1.default.createElement(Box_1.Box, tslib_1.__assign({ justify: "center", align: align }, innerThemeProps), content));
                    }
                    content = (react_1.default.createElement(Box_1.Box, tslib_1.__assign({ fill: true, direction: "row", justify: "between", align: "center" }, outerThemeProps),
                        content,
                        react_1.default.createElement(Searcher_1.Searcher, { filtering: filtering, filters: filters, property: property, onFilter: onFilter, onFiltering: onFiltering })));
                }
                else if (!onSort) {
                    content = (react_1.default.createElement(Box_1.Box, tslib_1.__assign({}, dataTableContextTheme, { fill: true, justify: "center", align: align }), content));
                }
                if (onResize) {
                    content = (react_1.default.createElement(Resizer_1.Resizer, { property: property, onResize: onResize }, content));
                }
                return (react_1.default.createElement(TableCell_1.TableCell, { key: property, scope: "col", plain: true, style: widths && widths[property] ? { width: widths[property] } : undefined }, content));
            }))));
};
var HeaderWrapper = recompose_1.compose(styled_components_1.withTheme)(Header);
exports.Header = HeaderWrapper;
//# sourceMappingURL=Header.js.map